<div class="tags has-addons">
  <span class="tag is-light">{{ selectedItems().length }}</span>
  <span class="tag" [class.is-primary]="!isActive()" [class.is-dark]="isActive()">{{
    transactions().length
  }}</span>
</div>
